<script>
import { mapState, mapGetters, mapActions } from "vuex";

export default {
  data() {
    return {
      confirmed: false
    };
  },
  computed: {
    ...mapState("newPurchase", ["professional_id", "information"]),
    ...mapGetters("newPurchase", [
      "startAtFormated",
      "dayFormated",
      "price",
      "textTakeProducts",
      "duration",
      "professional",
      "dayOfWeek",
      "frequency"
    ])
  },
  methods: {
    ...mapActions("newPurchase", ["sendToCart"])
  }
};
</script>

<template>
  <div id="orders" class="section">
    <div class="section-title">CONFIRME SEU PEDIDO
      <hr>
    </div>

    <div class="details">
      <div class="row">
        <div class="column flex-1">
          <b>Nome do cliente</b>
          <span v-if="dayFormated">Dia: {{dayFormated}}</span>
          <span v-if="dayOfWeek">Dia da semana: {{dayOfWeek}}</span>
          <span v-if="frequency">Frequencia: {{frequency}}</span>
          <span>Horário: {{startAtFormated}}</span>
          <span>Duração: {{duration}}h</span>
        </div>

        <div class="column flex-1">
          <b>Local</b>
          <span>CASA</span>
          <span>Rua General Argolo, 315 | Apto 507 | Centro - Pelotas/RS</span>
        </div>

        <div class="column flex-1">
          <b>Limpeza</b>
          <span>Profissional: {{(professional) ? professional.name : ''}}</span>
          <span>Valor: {{price.formated}}</span>
          <span>Produtos: {{textTakeProducts}}</span>
        </div>
      </div>

      <div class="informations mt-20">Informações:
        <p>{{information}}</p>
      </div>

      <div class="row justify-center">
        <div class="btn bg-pink pl-30 pr-30" @click="confirmed = true">confirmar</div>
      </div>
    </div>

    <transition name="fade" mode="out-in">
      <div
        v-if="confirmed"
        class="btn bg-pink pl-30 pr-30 mt-50"
      >{{(dayOfWeek) ? 'enviar solicitação' : 'enviar link de pagamento'}}</div>
    </transition>
  </div>
</template>

<style scoped>
.section {
  margin-bottom: 0;
}

.details {
  margin-top: 20px;
  font-size: 13px;
  border: 1px solid #eee;
  border-radius: 4px;
  padding: 20px;
}

.details .row .column {
  flex: 1;
  align-items: flex-start;
  margin: 10px;
  text-align: left;
}

.details .row .column:first-child {
  margin-left: 0;
}

.details .row .column:last-child {
  margin-right: 0;
}

.details .row .column span {
  margin: 2px 0;
}

.details .btn {
  margin-bottom: -38px;
}

.informations {
  display: flex;
  flex-direction: column;
  text-align: left;
}

.informations p {
  margin-left: 20px;
  white-space: pre;
  border-left: 1px solid #ddd;
  padding-left: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/_Shared/OrdersAndSubscriptions/Confirm.vue